import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import SelectableList from '../../../_shared/components/SelectableList';
import PaymentsOnHoldContext from '../Context';
import { FilterRowWrapper, FilterRowLastChild, FilterWrapper } from './Styles';

const Filter = () => {
  const {
    summary: { requirements },
    metadata: {
      filterDefinitions: { inputs: filters }
    },
    filterSelected,
    onFilterTrades
  } = useContext(PaymentsOnHoldContext);
  const filterMetadata = {
    id: 'filter',
    headline: <FormattedMessage id="list.filters.headertext" />,
    onClick: onFilterTrades,
    items: filters.map(({ value, key }) => ({
      selected: key === filterSelected,
      content: (
        <FilterRowWrapper>
          <div>{value}</div>
          <FilterRowLastChild filterSelected>
            {requirements[key]?.totalNumberOfTrades}
          </FilterRowLastChild>
        </FilterRowWrapper>
      )
    }))
  };

  return (
    <FilterWrapper>
      <SelectableList
        testId="payments-on-hold-filter"
        width={240}
        lists={[filterMetadata]}
      />
    </FilterWrapper>
  );
};

export default Filter;
